import React from 'react';
import { useSelector } from 'react-redux';

import CurrencyAmount from '@swf/components/CurrencyAmount/CurrencyAmount';
import type { CardViewProps } from '@swf/components/StarsMPNotification/config/NotificationTypes';
import { geti18NValueConfig } from '@swf/components/StarsMPNotification/utils';
import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';
import { License } from '@swf/core/types/Account';
import type { BonusNotification } from '@swf/core/types/Notification';
import { NotificationContainer } from '@swf/notification';

import sharedStyles from '../../../styles/shared.scss';
import Buttons from '../../Buttons/Buttons';

import {
  TXTCLI_Casino,
  TXTCLI_CongratulationsX_you_have_earn_ELL,
  TXTCLI_CongratulationsX_your_N0_N1_N2_ELL,
  TXTCLI_CongratulationsX_your_N0_N1_XX_ELL_2,
  TXTCLI_In_totalX_we_have_credited_you_ELL,
  TXTWCL_CongratulationsX_youXve_cleare_ELL_1
} from './Cleared.messages.json';

const Cleared: React.FC<CardViewProps & { cardData: BonusNotification }> = ({
  cardData: {
    amountToPay = 0,
    attributes,
    notificationId,
    currency,
    currentAmount,
    description,
    initialAmount = 0,
    isSplitWager,
    paidCash,
    redemptionLimitReached,
    type
  },
  viewConfig: { title, actions },
  onClickPrimaryAction
}) => {
  const license = useSelector(select.account.getLicense);

  const messageTag = redemptionLimitReached
    ? TXTCLI_CongratulationsX_your_N0_N1_XX_ELL_2
    : TXTCLI_CongratulationsX_your_N0_N1_N2_ELL;

  return (
    <NotificationContainer
      title={<Translation {...title.tag} values={geti18NValueConfig(title.values, attributes)} />}
      bodyClass={sharedStyles.alignLeft}
    >
      {[License.IT].includes(license) ? (
        <>
          <Translation
            tagName="p"
            {...TXTCLI_CongratulationsX_you_have_earn_ELL}
            values={{ 0: description }}
          />
          <Translation
            tagName="p"
            {...TXTCLI_In_totalX_we_have_credited_you_ELL}
            values={{ 0: <CurrencyAmount value={amountToPay} currency={currency} /> }}
          />
        </>
      ) : (
        <>
          {' '}
          {isSplitWager ? (
            <Translation
              tagName="p"
              {...TXTWCL_CongratulationsX_youXve_cleare_ELL_1}
              values={{
                0: description,
                1: (
                  <CurrencyAmount
                    currency={currency}
                    value={currentAmount * (paidCash / initialAmount)}
                  />
                ),
                2: (
                  <CurrencyAmount
                    currency={currency}
                    value={currentAmount - currentAmount * (paidCash / initialAmount)}
                  />
                )
              }}
            />
          ) : (
            <Translation
              tagName="p"
              {...messageTag}
              values={{
                0: <CurrencyAmount value={initialAmount} currency={currency} />,
                1: <Translation {...TXTCLI_Casino} />,
                2: description,
                3: <CurrencyAmount value={amountToPay} currency={currency} />
              }}
            />
          )}
        </>
      )}
      <Buttons
        actionList={actions}
        notificationType={type}
        attributes={attributes}
        notificationId={notificationId}
        onClickPrimaryAction={onClickPrimaryAction}
      />
    </NotificationContainer>
  );
};

export default Cleared;
